import React, { Component } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../../common_components/Footer";
import Header from "../../../common_components/Header";
import { withRouter } from "../../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
// 
class Media_kit extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />


                <div
                    className="breadcrumb-wrapper bg-cover"
                    style={{ backgroundImage: 'url("assets/img/breadcrumb.jpg")' }}
                >
                    <div className="border-shape">
                        <img src="assets/img/element_1.png" alt="shape-img" />
                    </div>
                    <div className="line-shape">
                        <img src="assets/img/line-element.png" alt="shape-img" />
                    </div>
                    <div className="container">
                        <div className="page-heading">
                            <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                Media Kit
                            </h1>
                            <ul className="breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                                <Link to='/'><li>Home </li></Link>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>News & PR</li>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>Media Kit</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <section className="Media_kit">
                    <div className="container">
                        <div className="row mt_40">
                            <div className="col-md-12">
                                <div className="GoodwillMessages_grid_View">
                                    <div className="main_div">
                                        <img src="assets/img/media_kit_21.png" />
                                        <div className="content_div">
                                            <p>ITMES Trade Services Logo</p>
                                            <a
                                                href="assets/img/media_kit_21.png"
                                                className="read_more_btn"
                                                style={{ width: "auto" }}
                                                target="_blank"
                                                download="img.png"
                                            >
                                                Download
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <Footer />
            </>
        )

    }
}
// ReactDOM.render(<Homepage />, document.querySelector('.demo-carousel'))

export default withRouter(connect(null, {})(Media_kit));